import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UserService } from 'app/shared/services/user.service';
import { Router } from '@angular/router';

@AutoUnsubscribe()
@Component({
  selector: 'cedato-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(public router: Router, public userService: UserService) {}

  ngOnInit() {
    this.router.navigate([this.userService.getDefaultRoute()]);
  }

  ngOnDestroy() {}
}
